import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

import Datetime from 'vue-datetime'

import './element-theme.scss'
import 'vue-datetime/dist/vue-datetime.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { Message, MessageBox } from 'element-ui'

import FontPicker from 'font-picker-vue'
import '@/setupVueEnv'

import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('icon', Icon)

import { KENV } from './types/admin'
import setupDebug from './setupDebug'
import env from './env'
setupDebug(env.environment as KENV)

locale.use(lang)
Vue.use(Datetime)
Vue.use(FontPicker)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

Vue.config.productionTip = false

new Vue({
  router,
  store: store.original,
  render: h => h(App)
}).$mount('#app')
